var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "content" }, [
      _c("span", { staticStyle: { color: "white", "font-weight": "bold" } }, [
        _vm._v(
          "INFO: Nese deshironi qe te vazhdoni qe te jeni aktiv dhe pse hapni dhe programe tjera ne telefonin tuaj, mjafton qe ta leshoni radion dhe nuk do te largoheni nga CHATI. Radio leshohet automatik por nese nuk leshohet atehere klikoni ne anen e majt te telefonit te lista e bisedave e keni radion lart, klikoni PLAY dhe vazhdoni chatin pa nderprerje."
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }